import { gatewayApiAgent } from './apiAgents';
import { FeedbackForm, FeedbackResponse } from '../api-types/director';

export function createFeedback(params: FeedbackForm) {
  return gatewayApiAgent
    .post<FeedbackResponse>('/director/public/v1/feedbacks', params)
    .then((res) => res.data);
}

export function updateFeedback(feedbackId: string, params: FeedbackForm) {
  return gatewayApiAgent
    .put<FeedbackResponse>(`/director/public/v1/feedbacks/${feedbackId}`, params)
    .then((res) => res.data);
}
